<template>
  <div v-title="$route.meta.title">
    <div class="page-heading">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>新宴席管理</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/banquet-task/records' }">宴席任务</el-breadcrumb-item>
        <el-breadcrumb-item>{{ $route.meta.title }}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <layout-panel>
      <template slot="header">基础信息</template>
      <el-table :data="basicRows"
                border
                :show-header="false"
                :cell-class-name="labelCellClass">
        <el-table-column prop="label"
                         width="160"></el-table-column>
        <el-table-column>
          <template slot-scope="scope">
            <router-link v-if="scope.row.to"
                         class="link-text"
                         :to="scope.row.to">
              {{ scope.row.value }}
            </router-link>
            <span v-else>{{ scope.row.value }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="label2"
                         width="160"></el-table-column>
        <el-table-column>
          <template slot-scope="scope">
            <router-link v-if="scope.row.to2"
                         class="link-text"
                         :to="scope.row.to2">
              {{ scope.row.value2 }}
            </router-link>
            <span v-else-if="scope.row.label2">{{ scope.row.value2 }}</span>
          </template>
        </el-table-column>
      </el-table>
    </layout-panel>

    <layout-panel>
      <template slot="header">宴席原始信息</template>
      <el-table :data="columnRows"
                border
                :show-header="false"
                :cell-class-name="labelCellClass">
        <el-table-column prop="label"
                         width="200"></el-table-column>
        <el-table-column prop="value">
          <template slot-scope="scope">
            {{ scope.row.value }}
          </template>
        </el-table-column>
        <el-table-column prop="label2"
                         width="200"></el-table-column>
        <el-table-column>
          <template slot-scope="scope">
            <span v-if="scope.row.label2">{{ scope.row.value2 }}</span>
          </template>
        </el-table-column>
      </el-table>
    </layout-panel>
  </div>
</template>

<script>
export default {
  data () {
    return {
      detail: {
        order_code: '',
        taskid: 0,
        title: '',
        task_status: '',
        project: '',
        batch: '',
        marketid: 0,
        market: '',
        checkin_start: '',
        checkin_end: '',
        task_end_time: '',
        created_at: '',
        columns: [],
      },
    }
  },
  computed: {
    taskLink () {
      if (!this.detail.taskid) {
        return null
      }
      return {path: '/task/table', query: {text: this.detail.taskid}}
    },
    marketLink () {
      if (!this.detail.marketid) {
        return null
      }
      return {name: '门店修改', params: {id: this.detail.marketid}}
    },
    taskText () {
      const title = this.detail.title || ''
      const taskid = this.detail.taskid || ''
      if (title && taskid) {
        return title + '（' + taskid + '）'
      }
      return title || String(taskid || '')
    },
    basicRows () {
      const start = this.detail.checkin_start || ''
      const end = this.detail.checkin_end || ''
      const windowText = start || end ? start + ' ~ ' + end : ''
      return [
        {label: '任务', value: this.taskText, to: this.taskLink, label2: '状态', value2: this.detail.task_status},
        {label: '项目', value: this.detail.project, label2: '批次', value2: this.detail.batch},
        {label: '门店', value: this.detail.market, to: this.marketLink, label2: '签到窗口', value2: windowText},
        {label: '任务结束时间', value: this.detail.task_end_time, label2: '导入时间', value2: this.detail.created_at},
      ]
    },
    columnRows () {
      const columns = this.detail.columns || []
      const rows = []
      for (let i = 0; i < columns.length; i += 2) {
        const right = columns[i + 1]
        rows.push({
          label: columns[i].label,
          value: columns[i].value,
          label2: right ? right.label : '',
          value2: right ? right.value : '',
        })
      }
      return rows
    },
  },
  created () {
    this.loadDetail()
  },
  watch: {
    '$route.params.id' () {
      this.loadDetail()
    },
  },
  methods: {
    labelCellClass ({row, columnIndex}) {
      if ((columnIndex === 0 && row.label) || (columnIndex === 2 && row.label2)) {
        return 'is-label'
      }
      return ''
    },
    loadDetail () {
      request.common('banquetTaskGet', this.$route.params.id).then(({data}) => {
        this.detail = {
          order_code: data.order_code || '',
          taskid: data.taskid || 0,
          title: data.title || '',
          task_status: data.task_status || '',
          project: data.project || '',
          batch: data.batch || '',
          marketid: data.marketid || 0,
          market: data.market || '',
          checkin_start: data.checkin_start || '',
          checkin_end: data.checkin_end || '',
          task_end_time: data.task_end_time || '',
          created_at: data.created_at || '',
          columns: data.columns || [],
        }
      })
    },
  },
}
</script>

<style lang="scss"
       scoped>
/deep/ td.is-label {
  background: #f5f7fa;
  color: #303133;
  font-weight: 600;
}

.link-text {
  color: #409EFF;
  text-decoration: none;

  &:hover {
    text-decoration: underline;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/banquet-task/pages/BanquetTaskRecordDetail.vue